import { render, staticRenderFns } from "./MbUserAvatarSelect.vue?vue&type=template&id=46c55c3c&scoped=true&"
import script from "./MbUserAvatarSelect.vue?vue&type=script&lang=js&"
export * from "./MbUserAvatarSelect.vue?vue&type=script&lang=js&"
import style0 from "./MbUserAvatarSelect.vue?vue&type=style&index=0&id=46c55c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c55c3c",
  null
  
)

export default component.exports